<template>
<div class="page_podstranka">
    <h1 class="top d-none" v-if="masterPage.link !== 'product_view_page_9_'">
      {{ masterPage.getItemMeta('meta', 'title').setAlternative(`${masterPage.title} | ${pageLink.getDomain()}`).value }}
    </h1>

    <nav id="main_menu_phone_top" class="navbar navbar-expand-lg navbar-light">
      <NuxtLink :to="`/${langCode.code}-${activeCountry.code}`" class="navbar-brand mx-auto" title="hladamchatu.sk, ubytovací portál">
        <img :src="`/img/logo_${activeCountry.code}.svg`" :alt="$t('main-logo-title-alt')" class="img-fluid logo-brand" width="247" height="25">
      </NuxtLink>
    </nav>

    <Section :section="getPageDataSection(pageData, 'navbar')" :page="masterPage"></Section>
    <main class="main">
      <Holder :holder="getPageDataHolder(pageData, 'Obsah')" :page="masterPage"></Holder>
    </main>
    <Section :section="getPageDataSection(pageData, 'footer')" :page="masterPage"></Section>
  </div>
</template>


<script setup lang="ts">
import {
  getPageDataHolder,
  getPageDataSection,
  obtainActiveLocale,
  obtainActiveWebCountry
} from "~/composables/master_page";
import PageLink from "~/lib/PageLink";
import Holder from "~/components/Holder.vue";
import Section from "~/components/Section.vue";
import {useRuntimeConfig} from "#app";
import Page from "../../../lib/models/Page";

const pageLink = new PageLink(useRuntimeConfig().public.WEB_URL);
const props = defineProps({
  pageData: {}
});
const masterPage = (new Page()).fromObject(props.pageData.page) as Page;
const langCode = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();
</script>
